<template>

    <section class="w-100 d-flex flex-column">
       
        <!-- Loading -->
        <loading/>

        <!-- Module Actions -->
        <module-action
            :csrftolken="csrftolken"
            :alldata="moduledata"
            @dynamic-data="getDynamicDataFromModuleAction($event)"
            :orderurl="moduleorder"
            :searchurl="modulesearch"
            classname=""
            idname="blogcategory_header"
            modulename="Blog Category List"
            searchplaceholder="search by id, type, email or name"
            :createlink="modulecreate"
        >

            <template #custom_action>
            </template>

        </module-action>

        <!-- Content -->
        <template v-if="Object.values(allData).length > 0">

            <!-- Page List Render-->
            <table-element :classname="['table-striped', 'mt-5']">

                <!-- THead -->
                <template #thead>
                    <tr>
                        <th scope="col" style="opacity:.5;">#Id</th>
                        <th scope="col">Created By</th>
                        <th scope="col">Name</th>
                        <th scope="col">Description</th>
                        <th scope="col">Image</th>
                        <th scope="col">Created</th>
                        <th scope="col">Updated</th>
                        <th scope="col">Actions</th>
                    </tr>
                </template>

                <!-- Tbody -->
                <template #tbody>

                    <tr v-for="(value, index) in allData" :key="value.id" :data-referindex="index" :data-categoryid="value.id">
                        
                        <th scope="row" style="opacity:.5;">{{ value.id }}</th>
                        <td>{{ value.user_name }}</td>
                        <td>{{ value.name }}</td>
                        <td>{{ resumeMessage(value.description, 15, 2) }}</td>
                        <template v-if="value.image_id !== null">
                            <td>
                                <img 
                                    :src=" value.image_data.thumb_exist ? 
                                    `${this.imagestoragepath}/${value.image_id}/thumb_${value.image_data.filenamenew}` : 
                                    `${this.imagestoragepath}/original_default.jpg`" 
                                    :alt="value.image_data.filealt" 
                                    width="190"
                                    height="90"
                                />

                                
                                
                                </td>
                        </template>
                        <template v-else>
                            <td>No Image</td>
                        </template>
                        <td>{{ value.created_at }}</td>
                        <td>{{ value.updated_at }}</td>
                        <td class="d-flex flex-row">
                            <button 
                                type="button" 
                                class="btn btn-secondary btnedit"
                                :data-referindex="index" 
                                :data-categoryid="value.id"
                                data-action="edit" 
                                @click="buttonActions($event)"
                            >Edit</button>
                            <button 
                                type="button" 
                                class="btn btn-danger ms-2 btnremove" 
                                :data-referindex="index" 
                                :data-categoryid="value.id"
                                data-action="remove"
                                @click="buttonActions($event)"
                            >Remove</button>
                        </td>

                    </tr>

                </template>

            </table-element>

            <!-- Pagination active -->
            <pagination 
                :totalpages="parseInt(totalpages)"
                :firstpageurl="firstpage"
                :otherpagesurl="filePageUrl"
                modulename="user"
            />

        </template>
     
        <!-- Back To Top -->
        <back-to-top 
            idhref="blogcategory_header"
        />

        <!-- Response Messages -->
        <div class="order-3 responsebasemessage" ref="responsebasemessage">

            <list-message/>

        </div>

    </section>

</template>
<script>
import fetchData from './../../fetchData.js';
import ListMessage from './../elements/ListMessageElement.vue';
import Loading from './../elements/LoadingElement.vue';
import Table from './../elements/TableElement.vue';
import Pagination from './../elements/PaginationElement.vue';
import BackToTop from './../elements/BackToTopElement.vue';
import ModuleAction from './../elements/ModuleActionElementNew.vue';
import Modal from './../elements/ModalElement.vue';
import htmlElements from './../../htmlElements';

'use strict';

export default{
    name: 'BlogCategoryAdmin',
    props:{

        csrftolken:{
            type: String,   
            required: true
        },
        moduledata:{
            type: String,   
            required: true
        },
        adminurl:{
            type: String,   
            required: true
        },
        modulesearch:{
            type: String,   
            required: true
        },
        moduleorder:{
            type: String,   
            required: true
        },
        modulefilter:{
            type: String,   
            required: true
        },
        modulecreate:{
            type: String,   
            required: true
        },
        moduleremove:{
            type: String,   
            required: true
        },
        totalpages:{
            type: String,   
            required: true
        },
        firstpage:{
            type: String,   
            required: true
        },
        imagestoragepath:{
            type: String,
            required: true
        },

    },
    data: () => {

        return{

            allData: {},
            moduleshow: '',
            modaltitle: '',
            modaldescription: '',
            modaloptions: {},
            activeclass: 'd-flex',
            filePageUrl:''

        }

    },
    created(){

        //Set Review Data
        this.allData = JSON.parse(this.moduledata);
    
        //Set Review Form Show Url
        this.moduleshow = this.adminurl + '/admin/website/blogcategory/id=';

        //Set Review Page Url
        this.filePageUrl = this.firstpage + '/page=';

    },
    methods:{

        resumeMessage(text, limit, divisor){

            //console.log(text);
            if(text !== undefined){

                let resume = text.length > limit ?
                `${text.substr(0, Math.round(text.length / divisor))}...` : text;

                return resume;

            }

        },
        getDynamicDataFromModuleAction(dynamicData){

            //Set Dynamic Data when clean search input
            if(dynamicData !== undefined && 
            typeof dynamicData === 'object' &&
            Object.values(dynamicData).length > 0){

                //Get Default Module Data
                this.allData = dynamicData;

            }

        },
        buttonActions(element){

            //Get Data for Button Action
            let id = element.currentTarget.getAttribute('data-categoryid');
            //let referindex = element.currentTarget.getAttribute('data-referindex');
            let action = element.currentTarget.getAttribute('data-action');

            //Set Action bu button
            switch(action){

                //Edit
                case 'edit':

                    window.location.replace(this.moduleshow + id);

                break;

                //Remove
                case 'remove':
                    
                    //Data Form
                    let dataForm = {
                        id: id,
                        action: action,
                    };

                    //Remove routine
                    this.removeData(dataForm);
                  
                break;

            }

        },
        removeResponseMessages(time = 5000){

            setTimeout(function(){

                //Remove active class
                document.querySelector('.responsebasemessage').classList.remove('d-flex');
                document.querySelector('.responsebasemessage').classList.remove('successmessage');
                document.querySelector('.responsebasemessage').classList.remove('errormessage');

                //Remove children elements
                let ul = document.querySelector('.responsebasemessage').children;

                [...ul[0].children].forEach((valli) => {

                    //Remove Elements
                    valli.remove();

                });

            }, time);

        },
        showModal(element, classname){

            //Set Modal Data
            this.modaltitle = element.name;
            this.modaldescription = element.description;
            this.modaloptions = element.options;

            //Show Modal
            $(`.${classname}`).modal("show");

            return;

        },
        hideModal(classname){

            //Hide Modal
            $(`.${classname}`).modal("hide");

            return;

        },
        removeData(data){

            //Disabled Button
            document.querySelector(`.btn${data.action}`).setAttribute('disabled', true);

            //Confirm Message
            let confirmMessage = `Favor confirmar a exclusão do user de id nº ${data.id} ?`;

            //Confirm Remove
            let confirmRemove = confirm(confirmMessage);

            if(!confirmRemove){

                //Enabled Button
                document.querySelector(`.btn${data.action}`).removeAttribute('disabled');

                return;

            }

            //Active Loading
            document.querySelector('.loadingbase').classList.add('d-flex');

            //Send Data
            let response = fetchData.structureTosendData(this.moduleremove, data, this.csrftolken, 'DELETE');

            //Check Promisse
            response.then((value) => {

                //Enabled Button
                document.querySelector(`.btn${data.action}`).removeAttribute('disabled');

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                //Add active Class
                this.$refs.responsebasemessage.classList.add(this.activeclass);
                this.$refs.responsebasemessage.classList.add(value.classname);

                //Element for append
                let li = `<li class="list-group item my-1">${value.message}</li>`;

                //Append Element
                $(li).appendTo(this.$refs.responsebasemessage.children);

                //Remove Message
                this.removeResponseMessages();

                //Set Att Data
                if(value.hasOwnProperty('attData')){

                    //Get Module Data
                    this.allData = value.attData;

                }
                

            }).catch((error) => {

                //Enabled Button
                document.querySelector(`.btn${data.action}`).removeAttribute('disabled');

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                throw new Error(error);

            });

        }

    },
    computed:{

        computedAllData(){

            return this.allData;

        },

    },
    watch:{

        computedAllData(){},

    },
    components:{

        listMessage: ListMessage,
        loading: Loading,
        tableElement: Table,
        pagination: Pagination,
        backToTop: BackToTop,
        moduleAction: ModuleAction,
        modal: Modal

    }

}

</script>